/** Parses "15m", "10s", "1h" or plain milliseconds (same format as the production client). */
export function parseDuration(value: string | undefined, fallbackMs: number): number {
  const raw = value?.trim();
  if (!raw) return fallbackMs;
  if (/^\d+$/.test(raw)) return Number(raw);
  const match = /^(\d+)([smh])$/i.exec(raw);
  if (!match) return fallbackMs;
  const amount = Number(match[1]);
  const unit = match[2]?.toLowerCase();
  const factor = unit === 'h' ? 3_600_000 : unit === 'm' ? 60_000 : 1_000;
  return amount * factor;
}

const flag = (value: string | undefined) => value === 'true' || value === '1';

export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:5555/api',
  /** Idle time before the logout warning appears (production default 15 minutes). */
  inactivityTimeoutMs: parseDuration(import.meta.env.VITE_INACTIVITY_TIMEOUT, 15 * 60_000),
} as const;

/** Feature flags. Marketing analytics is still disabled in production, so it is opt-in. */
export const features = {
  marketingAnalytics: flag(import.meta.env.VITE_FEATURE_MARKETING_ANALYTICS),
} as const;
